// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3SgGS","loading__icon":"Loading_loading__icon__3cm9m","rotate":"Loading_rotate__1Hy3U"};